<template>
    <div>
        <el-row class="u-mt-10 u-mb-20">
            <el-col :xs="24" :sm="16" :md="16">
                <el-input v-model="filtro['nome']" placeholder="Pesquisar curso..." @keyup.native.enter="loadingCursos"></el-input>
            </el-col>
            <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
                <el-button v-if="$store.state.user.tipo == 4" type="warning" plain icon="el-icon-connection" @click="dialogUnificar = true">UNIFICAR</el-button>
                <router-link to="/admin/curso/cadastro" class="btn-new-register u-ml-10">
                    <el-button type="primary">NOVO CURSO</el-button>
                </router-link>
            </el-col>
        </el-row>

        <unificar-cadastro
            :visible.sync="dialogUnificar"
            titulo="Unificar curso (série) duplicado"
            urlOpcoes="/api/curso/getAllCurso"
            urlUnificar="/api/curso/unificar"
            campoLabel="nome"
            @done="loadingCursos">
        </unificar-cadastro>
        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="hidden-mobile" style="width: 70px;">Cod.</th>
                        <th>Nome</th>
                        <th class="u-text-center">Modalidade Nacional</th>                        
                        <th class="hidden-mobile u-text-center">Tipo de Ensino</th>
                        <th class="hidden-mobile u-text-center">Status</th>
                        <th style="width: 150px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td class="hidden-mobile">{{ item.id }}</td>
                        <td>{{ item.nome }}</td>
                        <td class="u-text-center">{{ (item.curso_nacional_equivalente) ? $CONSTANTS.CURSO_NACIONAL[item.curso_nacional_equivalente] : '-' }}</td>                        
                        <td class="hidden-mobile u-text-center">{{ $CONSTANTS.TIPO_ENSINO[item.tipo_ensino] }}</td>
                        <td class="hidden-mobile u-text-center">{{ (item.situacao) ? 'Ativo' : 'Inativo' }}</td>
                        <td class="u-text-center acao"> 
                            <router-link :to="'/admin/curso/edit/'+ item.id" class="link-icon" style="color: rgba(0, 0, 0, 0.87) !important;">
                                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                            </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                            <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                </el-col>
            </el-row>
        </div>

    </div>
</template>
<script>

import UnificarCadastro from '@/shared/unificar-cadastro/unificar-cadastro.vue'

export default {
    data: () => ({
        statusList: false,
        dialogUnificar: false,
        filtro: {
            nome: ''
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [ ]
    }),
    mounted () {
      this.loadingCursos()
    },
    methods: {
        loadingCursos(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/curso/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        deleteCurso(id){

            this.$msgbox.confirm('Tem certeza que deseja excluir esta curso?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                    
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/curso/delete/` + id, this.$store.getters.getHeaderAuth).then(response => {
                            
                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingCursos();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingCursos();
        }
    },
    components:{ UnificarCadastro }
}
</script>